import * as Yup from 'yup';

export const validateEmailFormSchema = Yup.object().shape({
  code: Yup.string()
    .required()
    .matches(/^[0-9]+$/)
    .min(6)
    .max(6)
    .required()
    .label('Verification code'),
});
